export default {
  "fontElementMap": "OQ2OF",
  "elementSpacing": "rWHrn",
  "text": "HliLS rWHrn",
  "child": "BF1L-"
};